/**
 * Mixin pour la gestion des lecteurs Bluetooth de transpondeurs équins.
 * Gère la connexion, la lecture des caractéristiques BLE et le nettoyage des ressources.
 */
var BluetoothMixin = {
  data() {
    return {
      /** @type {BluetoothDevice|null} Device Bluetooth connecté */
      bluetoothDevice: null,
      /** @type {BluetoothRemoteGATTCharacteristic|null} Caractéristique BLE pour les notifications */
      bluetoothCharacteristic: null,
      /** @type {boolean} Indique si le scan Bluetooth est actif */
      bluetoothScanning: false
    }
  },

  beforeDestroy() {
    this.cleanupBluetooth()
  },

  methods: {
    /**
     * Nettoie les ressources Bluetooth (listeners et connexion).
     * Appelé automatiquement dans beforeDestroy.
     */
    cleanupBluetooth() {
      if (this.bluetoothCharacteristic) {
        this.bluetoothCharacteristic.removeEventListener(
          'characteristicvaluechanged',
          this.onBluetoothCharacteristicChange
        )
        this.bluetoothCharacteristic = null
      }
      if (this.bluetoothDevice && this.bluetoothDevice.gatt && this.bluetoothDevice.gatt.connected) {
        this.bluetoothDevice.gatt.disconnect()
        this.bluetoothDevice = null
      }
      this.bluetoothScanning = false
    },

    /**
     * Traite les données reçues via Bluetooth (caractéristique BLE).
     * Extrait les numéros de transpondeur au format XXX XXXXXXXXXXXX.
     * @param {Event} event - Événement characteristicvaluechanged
     * @returns {string|null} Numéro de transpondeur extrait ou null
     */
    parseBluetoothTransponder(event) {
      let enc = new TextDecoder('windows-1258')
      enc = enc.decode(event.target.value)
      const regex = /([0-9]{3} [0-9]{12})/
      let str = null
      if ((str = regex.exec(enc)) !== null) {
        return str[0].replace(' ', '').trim()
      }
      return null
    },

    /**
     * Handler par défaut pour les changements de caractéristique Bluetooth.
     * À surcharger dans le composant pour définir la propriété cible.
     * @param {Event} event - Événement characteristicvaluechanged
     */
    onBluetoothCharacteristicChange(event) {
      // À surcharger dans le composant
      console.warn('BluetoothMixin: onBluetoothCharacteristicChange doit être surchargé')
    },

    /**
     * Démarre ou arrête le scan Bluetooth pour les lecteurs de transpondeurs.
     * Se connecte au service BLE 0000ffe0 et écoute la caractéristique 0000ffe1.
     */
    scanBluetooth() {
      try {
        if (this.bluetoothDevice != null) {
          this.bluetoothDevice.gatt.disconnect()
          this.bluetoothDevice = null
          this.bluetoothCharacteristic = null
          this.bluetoothScanning = false
          return
        }

        navigator.bluetooth.requestDevice({
          optionalServices: ['0000ffe0-0000-1000-8000-00805f9b34fb'],
          acceptAllDevices: true
        })
        .then(device => {
          this.bluetoothDevice = device
          return device.gatt.connect()
        })
        .then(server => {
          return server.getPrimaryService('0000ffe0-0000-1000-8000-00805f9b34fb')
        })
        .then(service => {
          return service.getCharacteristic('0000ffe1-0000-1000-8000-00805f9b34fb')
        })
        .then(characteristic => {
          return characteristic.startNotifications()
        })
        .then(characteristic => {
          this.bluetoothCharacteristic = characteristic
          characteristic.addEventListener('characteristicvaluechanged', this.onBluetoothCharacteristicChange)
          this.bluetoothScanning = true
        })
        .catch(error => {
          this.failureToast("toast.enable_bluetooth_error")
        })
      } catch(e) {
        this.failureToast("toast.enable_bluetooth_error")
      }
    }
  }
}

export default BluetoothMixin
